import { Suspense } from "react";
import "./App.css";
import CONSTANTS from "./constants/constants";
import AntComponent from "antd/lib/app";
import { Spin } from "antd";
import { CustomSpin } from "./assets/icons/icons";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import labels from "./pages/errors/errorLabels";

import ErrorBoundaries from "./pages/errors/errorBoundary";
import OpLanding from "./pages/operator/opLanding";
import SupervisorLanding from "./pages/supervisor/supervisorLanding";
import SupervisorToteInfo from "./pages/supervisor/SupervisorToteInfo";
import SupervisorTrolleyInfo from "./pages/supervisor/SupervisorTrolleyInfo";
import ToteInfo from "./pages/operator/ToteInfo";
import TrolleyInfo from "./pages/operator/TrolleyInfo";
import LocationInfo from "./pages/operator/LocationInfo";
import RegisterTrolleyError from "./pages/operator/RegisterTrolleyError";
import RegisterTrolleyReview from "./pages/operator/RegisterTrolleyReview";
import RegisterToteError from "./pages/operator/RegisterToteError";
import RegisterToteReview from "./pages/operator/RegisterToteReview";
import TrolleyLocationWarning from "./pages/operator/TrolleyLocationWarning";
import NoAuth from "./pages/errors/401";
import NoAccess from "./pages/errors/403";
import Login from "./pages/common/login";

const {
  PAGE_ROUTES: {
    DEFAULT,
    OP_LANDING,
    SUPERVISOR_LANDING,
    SUPERVISOR_TOTE_INFO,
    SUPERVISOR_TROLLEY_INFO,
    TOTE_INFO,
    TROLLEY_INFO,
    LOCATION_INFO,
    REGISTER_TROLLEY_ERROR,
    REGISTER_TROLLEY_REVIEW,
    REGISTER_TOTE_ERROR,
    REGISTER_TOTE_REVIEW,
    TROLLEY_LOCATION_WARNING,
  },
} = CONSTANTS;

const {
  ERROR_PAGE: { NO_ACCESS, NO_AUTH },
} = labels;

function App() {
  const queryClient = new QueryClient();
  const routes = [
    // error routes
    { path: NO_AUTH, element: <NoAuth /> },
    {
      path: NO_ACCESS,
      element: <NoAccess />,
    },

    // authentication routes
    { path: DEFAULT, element: <Login /> },

    // operator routes
    { path: OP_LANDING, element: <OpLanding /> },
    { path: TOTE_INFO, element: <ToteInfo /> },
    { path: TROLLEY_INFO, element: <TrolleyInfo /> },
    { path: LOCATION_INFO, element: <LocationInfo /> },
    { path: REGISTER_TROLLEY_ERROR, element: <RegisterTrolleyError /> },
    { path: REGISTER_TROLLEY_REVIEW, element: <RegisterTrolleyReview /> },
    { path: REGISTER_TOTE_ERROR, element: <RegisterToteError /> },
    { path: REGISTER_TOTE_REVIEW, element: <RegisterToteReview /> },
    { path: TROLLEY_LOCATION_WARNING, element: <TrolleyLocationWarning /> },

    // supervisor routes
    { path: SUPERVISOR_LANDING, element: <SupervisorLanding /> },
    { path: SUPERVISOR_TOTE_INFO, element: <SupervisorToteInfo /> },
    { path: SUPERVISOR_TROLLEY_INFO, element: <SupervisorTrolleyInfo /> },
  ];

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Spin indicator={<CustomSpin />} />}>
          <AntComponent>
            <Routes>
              {routes.map(({ path, element }) => (
                <Route
                  key={path}
                  path={path}
                  element={<ErrorBoundaries>{element}</ErrorBoundaries>}
                />
              ))}
            </Routes>
          </AntComponent>
        </Suspense>
      </QueryClientProvider>
    </>
  );
}

export default function MainApp() {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
